module.exports = __webpack_public_path__ + "images/emoji/tiger.335ac5729cee03acbf9a.png";